<script setup lang="ts">
import {
  iKeyIcon,
  iKeyIconSize,
  iKeyIconStyle,
  iKeyIconType,
} from '@inscribe/signal';

const items = [
  'Designed to surface key insights clearly',
  'Unified view of customers risk and supporting evidence',
  'Understand why a customer is high, medium, or low risk',
];

defineExpose({ iKeyIconSize, iKeyIconStyle, iKeyIconType, items });
</script>

<template>
  <div class="risk-analysis-launch-content d-flex flex-column i-gap-10">
    <div class="text i-text-body-2">
      The new Risk Analysis page unifies all customer-level insights into one
      clear, easy-to-navigate view. Every insight is organized for clarity,
      helping you make more informed decisions.
    </div>
    <div class="list d-flex flex-column i-gap-6">
      <div
        class="item d-flex flex-row align-items-center i-gap-6"
        v-for="item in items"
        :key="item"
      >
        <i-key-icon
          :size="iKeyIconSize.XXS"
          :icon-style="iKeyIconStyle.SOLID"
          :type="iKeyIconType.SUCCESS"
          icon="small_check_1"
        ></i-key-icon>
        <div class="text i-text-subheading-2">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.risk-analysis-launch-content {
  .i-key-icon {
    width: 20px;
    height: 20px;
    padding: 3px;
  }
}
</style>
